import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../UserAccountLinker.module.scss';

const JwtError = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.statusCard}>
          <h2>{t("invite.unable_to_find_title")}</h2>
          <p>
            {t("invite.unable_to_find_message")}
          </p>
        </div>
    );
};

export default JwtError;